export default "__VITE_ASSET__DZNZH0BA__"